import ObjectID from 'bson-objectid';

export const generateNewBlockId = () => {
  return new ObjectID().toHexString();
};
